




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class HeaderC extends Vue {
  @Prop({ default: '' }) title!: String;
}
